import { z } from 'zod';

export const LoginRequestSchema = z.object({
  email: z.string().email(),
  password: z.string().min(1).max(200),
});

export type LoginRequest = z.infer<typeof LoginRequestSchema>;
